module.exports = __webpack_public_path__ + "assets/images/list-emerald.svg?326d68b4a770c4899efe0198e21840da";


//////////////////
// WEBPACK FOOTER
// ./_source/images/icons/sessions/list-emerald.svg
// module id = 635
// module chunks = 0